// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"878ed105","592":"cd7cd9b5"}[chunkId] + ".chunk.js";
};